<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="setNotFound">
  <h2>Redemption Code Set Not Found</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="(serverError === null) && !setNotFound">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item"><a routerLink="/redemption-codes">
        Redemption Codes
      </a></li>
      <li class="breadcrumb-item active" aria-current="page"
          *ngIf="loadingRedemptionCodeSet">
        Loading...
      </li>
      <li class="breadcrumb-item active" aria-current="page"
          *ngIf="!loadingRedemptionCodeSet">
        {{ redemptionCodeSet.name }}
      </li>
    </ol>
  </nav>

  <h2 *ngIf="loadingRedemptionCodeSet">
    Loading...
  </h2>

  <ng-container *ngIf="!loadingRedemptionCodeSet">

    <div class="row">

      <div class="col-12 col-md-6">

        <div class="mb-1">
          Name:
          <b>{{ redemptionCodeSet.name }}</b>
          <a href="#" class="ml-2"
             (click)="$event.preventDefault();openRenameModal();">
            Edit
          </a>
        </div>

        <div class="mb-1">
          Product:
          <b>
            {{ getRedemptionCodeSetProductTypeDisplay(redemptionCodeSet.product_type) }}
            - {{ redemptionCodeSet.product_name }}
          </b>
        </div>

        <div class="mb-1">
          Expiration Date:
          <b>
            <span *ngIf="redemptionCodeSet.expiration_date"
                  class="dashed-underline"
                  ngbTooltip="The codes expire at midnight on the end of this date, in the time zone of your organization.">
              {{ dateStringFromISO8601(redemptionCodeSet.expiration_date) }}
            </span>
            <span *ngIf="!redemptionCodeSet.expiration_date" class="text-muted">
              None
            </span>
          </b>
          <a href="#" class="ml-2"
             (click)="$event.preventDefault();openEditExpirationModal();">
            Edit
          </a>
        </div>

      </div>

      <div class="col-12 col-md-6">

        <div class="mb-1">
          Status:
          <b>
            <span *ngIf="redemptionCodeSet.status === RedemptionCodeSetStatus.available"
                  class="text-success">
              Available
            </span>
            <span *ngIf="redemptionCodeSet.status === RedemptionCodeSetStatus.expired"
                  class="text-danger">
              Expired
            </span>
            <span *ngIf="redemptionCodeSet.status === RedemptionCodeSetStatus.depleted"
                  class="text-muted">
              Depleted
            </span>
          </b>
        </div>

        <div class="mb-1">
          # of Codes:
          <b>{{ redemptionCodeSet.num_codes }}</b>
        </div>

        <div class="mb-1">
          # of Unused Codes:
          <b>{{ redemptionCodeSet.num_codes_available }}</b>
        </div>

        <div class="mb-1">
          # of Redeemed Codes:
          <span class="text-muted" *ngIf="loadingRedemptionCodes">
            Loading...
          </span>
          <b *ngIf="!loadingRedemptionCodes">
            {{ getNumberOfRedeemedCodes() }}
          </b>
        </div>

      </div>

    </div>

    <div class="mb-1">
      Created By:
      <b>
        {{ getStaffNameDisplay(redemptionCodeSet.created_by_first_name, redemptionCodeSet.created_by_last_name, redemptionCodeSet.created_by_email) }}
        at
        {{ timeStringFromISO8601(redemptionCodeSet.created_at, orgConfig.getOrganizationConfig().time_zone) }},
        {{ dateStringFromISO8601(redemptionCodeSet.created_at, orgConfig.getOrganizationConfig().time_zone) }}
      </b>
    </div>

    <div class="mb-1">
      Last Updated By:
      <b>
        {{ getStaffNameDisplay(redemptionCodeSet.last_updated_by_first_name, redemptionCodeSet.last_updated_by_last_name, redemptionCodeSet.last_updated_by_email) }}
        at
        {{ timeStringFromISO8601(redemptionCodeSet.updated_at, orgConfig.getOrganizationConfig().time_zone) }},
        {{ dateStringFromISO8601(redemptionCodeSet.updated_at, orgConfig.getOrganizationConfig().time_zone) }}
      </b>
    </div>

    <div class="mt-2">

      <button class="btn btn-outline-primary float-right mb-1"
              type="button"
              [disabled]="loadingRedemptionCodes"
              [class.disabled]="loadingRedemptionCodes"
              (click)="openExportCodesModal()">
        Export Codes
      </button>

      <a class="btn btn-outline-primary float-right mb-1 mr-2"
         *ngIf="accountService.getMyAccount().can_access_reports"
         routerLink="/reporting/redemption-codes"
         [queryParams]="{redemption_code_set_id: redemptionCodeSetIdInt}">
        View Report
      </a>

      <select class="custom-select w-auto"
              [(ngModel)]="redemptionCodeStatus">
        <option [ngValue]="null">
          Show all redemption codes
        </option>
        <option [ngValue]="RedemptionCodeStatus.available">
          Show available redemption codes
        </option>
        <option [ngValue]="RedemptionCodeStatus.redeemed">
          Show redeemed redemption codes
        </option>
      </select>

    </div>

    <div class="rounded-table-wrapper rounded-table-tight table-responsive position-relative mt-1">
      <table class="table">
        <thead>
        <tr>
          <th>Code</th>
          <th>Status</th>
        </tr>
        </thead>

        <tbody *ngIf="redemptionCodes === null">
        <tr>
          <td colspan="99" class="text-muted">Loading...</td>
        </tr>
        </tbody>

        <tbody *ngIf="redemptionCodes !== null">
        <div *ngIf="loadingRedemptionCodes" class="loading-overlay-container rounded">
          <h1 class="loading-overlay-text">Loading...</h1>
        </div>
        <tr *ngFor="let rc of getFilteredRedemptionCodes()">
          <td>{{ rc.code }}</td>
          <td>
            <ng-container *ngIf="rc.status === RedemptionCodeStatus.available">
              <span *ngIf="redemptionCodeSet.status !== RedemptionCodeSetStatus.expired"
                    class="text-success">
                Available
              </span>
              <span *ngIf="redemptionCodeSet.status === RedemptionCodeSetStatus.expired"
                    class="text-muted">
                Expired
              </span>
            </ng-container>
            <span *ngIf="rc.status === RedemptionCodeStatus.redeemed">
              Redeemed by
              <a routerLink="/customers/{{ rc.redeemed_by_id }}">
                {{ rc.redeemed_by_first_name }} {{ rc.redeemed_by_last_name }}
              </a>
            </span>
            <span *ngIf="rc.status === RedemptionCodeStatus.expired"
                  class="text-danger">
              Manually Expired
            </span>
          </td>
        </tr>
        <tr *ngIf="getFilteredRedemptionCodes().length === 0">
          <td colspan="99" class="text-muted">No codes match filters</td>
        </tr>
        </tbody>
      </table>
    </div>

  </ng-container>

  <div class="floating-alert-container">
    <div class="alert alert-dismissible"
         [class.alert-success]="callbackResult.status === CallbackResultStatus.success"
         [class.alert-danger]="callbackResult.status === CallbackResultStatus.error"
         role="alert" *ngIf="callbackResult !== null">
      {{ callbackResult.text }}
      <button type="button" class="close" (click)="callbackResult = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

</div>
